import { render, staticRenderFns } from "./MenuDashBoard.vue?vue&type=template&id=ba0c9b80"
import script from "./MenuDashBoard.vue?vue&type=script&lang=js"
export * from "./MenuDashBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports